import LiveStreamChat from "../../../components/LiveStreamChat";

const ViewFlatList = (props) => {
  const { user, chats, videoId, categoryId, cardId } = props;
  return (
    <>
        <LiveStreamChat
          chats={chats}
          videoId={videoId}
          categoryId={categoryId}
          cardId={cardId}
        >
        </LiveStreamChat>
    </>
  );
};

export default ViewFlatList;